import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'contract_not_found.title',
  },
  subTitle: {
    id: 'contract_not_found.sub_title',
  },
  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
});
